import React, { useEffect, useState } from "react";
import "./blog.scss";
import { Link } from "react-router-dom";
import {
  getFeaturedBlogs,
  getFeaturedCategoriesBlogs,
} from "../../utils/services";
import { formatBlogsDate } from "../../utils/helpers";
import { useTheme } from "../../contexts/ThemeProvider";
import CustomPagination from "../CustomPagination";
import { BLOGS_PER_PAGE, DARK_THEME } from "../../utils/constants";
import Loader from "../../hooks/loader";
import Footer from "../landing/footer/Footer";
import SEO from "../SEO";
const Blog = () => {
  const [latestBlogs, setLatestBlogs] = useState([]);
  const [featuredCategoryBlog, setFeaturedCategoryBlog] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const { theme } = useTheme();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    (async () => {
      window.scrollTo(0, 0);
      const featuresBlogsCategoriesData = await getFeaturedCategoriesBlogs();
      setFeaturedCategoryBlog(featuresBlogsCategoriesData[0]);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        window.scrollTo(0, 0);
        const blogsData = await getFeaturedBlogs(BLOGS_PER_PAGE, currentPage);
        setLatestBlogs(blogsData?.data);
        setTotalPages(blogsData?.totalPages);
      } catch (error) {
        console.error("error in getting blogs data:", error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [currentPage]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <SEO
        url='https://www.rain.one/blog'
      />
      {isLoading ? (
        <div className="spinner__wrapper">
          <Loader />
        </div>
      ) : (

        <section className="blogs__details">
          <div className="custom-container">
            <div className="innner_blogs_Detail">
              <Link to="/">
                <span className="logspaan">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M2.41453 8.60172L7.47703 3.53922C7.58258 3.43367 7.72573 3.37437 7.875 3.37437C8.02427 3.37437 8.16742 3.43367 8.27297 3.53922C8.37852 3.64477 8.43781 3.78792 8.43781 3.93719C8.43781 4.08645 8.37852 4.22961 8.27297 4.33516L4.17023 8.43719L15.1875 8.43719C15.3367 8.43719 15.4798 8.49645 15.5852 8.60194C15.6907 8.70743 15.75 8.8505 15.75 8.99969C15.75 9.14887 15.6907 9.29195 15.5852 9.39743C15.4798 9.50292 15.3367 9.56219 15.1875 9.56219L4.17023 9.56219L8.27297 13.6642C8.37852 13.7698 8.43781 13.9129 8.43781 14.0622C8.43781 14.2115 8.37852 14.3546 8.27297 14.4602C8.16742 14.5657 8.02427 14.625 7.875 14.625C7.72573 14.625 7.58258 14.5657 7.47703 14.4602L2.41453 9.39766C2.36223 9.34542 2.32074 9.28338 2.29243 9.21509C2.26413 9.1468 2.24956 9.07361 2.24956 8.99969C2.24956 8.92577 2.26413 8.85257 2.29243 8.78428C2.32074 8.716 2.36223 8.65396 2.41453 8.60172Z"
                      fill="#E6FF00"
                    />
                  </svg>{" "}
                  BLOG
                </span>
              </Link>

              <h3>Featured Blogs</h3>
              <div className="Outerr_main">
                <div className="lefft_sidee">
                  <div className="innar_smalll">
                    <h4>ARTICLE</h4>
                    <h5>{featuredCategoryBlog?.category_name}</h5>
                  </div>
                  <h2>{featuredCategoryBlog?.title?.rendered}</h2>
                  <h6>{formatBlogsDate(featuredCategoryBlog?.date)}</h6>
                  <Link to={`/blog-detail?slug=${featuredCategoryBlog?.slug}`} >
                    <img
                      className="arrrow_bottommm"
                      src="\assets\blog\arrow-img.svg"
                    />
                  </Link>
                </div>
                <div className="right-side-img">
                  <img
                    src={
                      featuredCategoryBlog?.jetpack_featured_media_url
                        ? featuredCategoryBlog.jetpack_featured_media_url
                        : "/assets/blog/blogmainimg.png"
                    }
                    alt="Featured blog"
                    className="img-fluid desktopimg"
                  />
                </div>
              </div>
            </div>
            <div className="detail__Side">
              <span>ARTICLES</span>
              <h2>Latest Blogs</h2>
              <div className="carddds_blogs">
                {latestBlogs && latestBlogs.length > 0 ? (
                  latestBlogs.map((blog, index) => (
                    <Link to={`/blog-detail?slug=${blog?.slug}`} key={index}>
                      <div className="first_cards">
                        <img
                          src={
                            blog?.jetpack_featured_media_url
                              ? blog?.jetpack_featured_media_url
                              : "/assets/blog/blogmainimg.png"
                          }
                          className="img-fluid imgcards"
                          alt="blog"
                        />
                        <h3>
                          ARTICLE{" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="3"
                            height="4"
                            viewBox="0 0 3 4"
                            fill="none"
                          >
                            <circle cx="1.5" cy="2" r="1.5" fill="#8A8A8A" />
                          </svg>
                          <span>{blog?.category_name}</span>
                        </h3>
                        <h4>{blog?.title?.rendered}</h4>

                        <p>{formatBlogsDate(blog?.date)}</p>
                      </div>
                    </Link>
                  ))
                ) : (
                  <div>No blogs found</div>
                )}
              </div>

              <div className="paginations_tabs">
                <CustomPagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </section>
      )}
      <Footer />
    </>
  );
};

export default Blog;
